import { __assign } from "tslib";
export function i18n(element, i18nImpl) {
    if (i18nImpl) {
        element.ownerDocument.defaultView.i18n = i18nImpl;
    }
    return element.ownerDocument.defaultView.i18n;
}
export function i18nMergeTranslation(defaultValues, attrs) {
    if (attrs) {
        return __assign(__assign({}, defaultValues), attrs.i18n);
    }
    return defaultValues;
}
export function i18nProperty(ns, defaults, options) {
    return function (target, propertyKey) {
        var setter = Object.getOwnPropertyDescriptor(target, propertyKey).set;
        var getter = Object.getOwnPropertyDescriptor(target, propertyKey).get;
        Object.defineProperty(target, propertyKey, {
            set: function (newValue) {
                this["__" + propertyKey + "Value"] = deepMerge(translateAll(defaults, i18n(this), ns, options || {}), newValue);
                if (setter) {
                    setter.call(this, this["__" + propertyKey + "Value"]);
                }
            },
            get: function () {
                if (typeof this["__" + propertyKey + "Value"] === 'undefined') {
                    this[propertyKey] = {};
                }
                if (getter) {
                    return getter.call(this);
                }
                else {
                    return this["__" + propertyKey + "Value"];
                }
            }
        });
    };
}
function deepMerge(host, extra) {
    Object.keys(extra).forEach(function (key) {
        if (typeof host[key] === 'object') {
            deepMerge(host[key], extra[key]);
        }
        else {
            host[key] = extra[key];
        }
    });
    return host;
}
function translateAll(defaultValues, i18nInstance, ns, options) {
    var result = {};
    Object.keys(defaultValues).forEach(function (key) {
        switch (typeof defaultValues[key]) {
            case 'string': {
                var fullKey = ns + "." + key;
                if (i18nInstance) {
                    result[key] = i18nInstance.t(fullKey, {
                        defaultValue: defaultValues[key] || fullKey
                    });
                }
                else {
                    result[key] = defaultValues[key] || fullKey;
                }
                break;
            }
            case 'object': {
                if (options.translateObjects && options.translateObjects[key]) {
                    var keyOptions = options.translateObjects[key];
                    var childNs = keyOptions.nsOverride
                        ? keyOptions.nsOverride
                        : "ns." + key;
                    result[key] = translateAll(defaultValues[key], i18nInstance, childNs, options);
                }
                else {
                    result[key] = defaultValues[key];
                }
                break;
            }
            default: {
                result[key] = defaultValues[key];
            }
        }
    });
    return result;
}
